module.exports = __webpack_public_path__ + "img/about1-mob.e19d3d4f.jpg";